import {
  SET_CURRENT_USER,
  CHANGE_DIVISION,
  UPDATE_USER_INFO,
  UPDATE_ACTIVE_PHONE,
  UPDATE_OFFICE_EXT,
  PASSWORD_RESETTING,
  TOKEN_REFRESHED,
  SET_RC_SESSION,
} from './types'
import isEmpty from '../../../utils/isEmpty'

const initialState = {
  isAuthenticated: false,
  user: {},
  passwordReset: {
    success: false,
  },
  isTokenRefreshed: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case TOKEN_REFRESHED:
      return {
        ...state,
        isTokenRefreshed: action.payload,
      }
    case SET_CURRENT_USER:
      let userDivision = {
        division_id: action.payload.division_id,
        divisionName: action.payload.divisionName,
      }

      try {
        const currentDivision = JSON.parse(sessionStorage.getItem('current_division') || '{}')
        if (!currentDivision || Object.keys(currentDivision).length === 0) {
          console.log('setting current division')

          sessionStorage.setItem('current_division', JSON.stringify(userDivision))
        } else {
          if (currentDivision?.division_id !== action.payload.division_id) {
            userDivision = currentDivision
          }
        }
      } catch (error) {
        console.log('error', error)
      }

      const user = { ...action.payload, ...userDivision }

      return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        user,
      }
    case CHANGE_DIVISION:
      sessionStorage.setItem(
        'current_division',
        JSON.stringify({
          division_id: action.payload.id,
          divisionName: action.payload.name,
        })
      )
      return {
        ...state,
        user: { ...state.user, division_id: action.payload.id, divisionName: action.payload.name },
      }
    case SET_RC_SESSION:
      return {
        ...state,
        user: { ...state.user, rcSession: action.payload },
      }
    case UPDATE_USER_INFO:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      }
    case UPDATE_OFFICE_EXT:
      return {
        ...state,
        user: {
          ...state.user,
          officeExt: action.payload,
        },
      }
    case UPDATE_ACTIVE_PHONE:
      return {
        ...state,
        user: {
          ...state.user,
          activePhone: action.payload,
        },
      }
    case PASSWORD_RESETTING:
      return {
        ...state,
        passwordReset: {
          success: action.payload,
        },
      }
    default:
      return state
  }
}
